export const KEYS = {
  HOME: 'home',
  BLOCKED: 'blocked',
  INTENDED: 'intended',
  INVOICE_CREATE: 'invoice-create',
  INVOICE_LIST: 'invoice-list',
  INVOICE_SINGLE: 'invoice-single',
  INVOICE_SETTINGS: 'invoice-settings',
  CLIENT_LIST: 'client-list',
  CLIENT_DETAIL: 'client-detail',
  CLIENT_CREATE: 'client-create',
  HAS_COMPANY: 'has_company',
  LOGIN: 'login',
  FORGOT_PASSWORD: 'forgot-password',
  RESET_PASSWORD: 'reset-password',
  VERIFY_EMAIL: 'verify-email',
  REGISTRATION_COMPLETE: 'registration-complete',
  DASHBOARD: 'dashboard',
  MODAL: 'modal',
  SIGNUP: 'signup',
  PROFILE: 'profile',
  ACCOUNT: 'account',
  COMPANY: 'company',
  WELCOME: 'welcome',
  MY_COMPANY: 'my-company',
  GENERAL: 'general',
  LINES: 'lines',
  SETTINGS: 'settings',
  TERMS: 'terms',
  QUOTE_LIST: 'quotes-list',
  QUOTE_SINGLE: 'quotes-single',
  QUOTE_CREATE: 'quotes-create',
  QUOTE_SETTINGS: 'quotes-settings',
  PRODUCT_LIST: 'product-list',
  PRODUCT_CREATE: 'product-create',
  PRODUCT_DETAIL: 'product-detail',
}

export const STORES = {
  AUTH: 'auth',
  CLIENT: 'client',
  COMPANY: 'company',
  DASHBOARD: 'dashboard',
  EMAIL: 'email',
  INVOICE: 'invoice',
  KVK: 'kvk',
  UI: 'ui',
  USER: 'user',
  QUOTATION: 'quotation',
}

export const STORE_KEYS = {
  BILLING_STATUS: 'billing_status',
  COMPANY: 'company',
  COMPANIES: 'companies',
  COLUMNS: 'columns',
  COUNTRIES: 'countries',
  CLIENT_CONTACTS: 'clientContacts',
  CLIENT_CONTACT: 'clientContact',
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  EMAIL_TEMPLATES: 'emailTemplates',
  EMAIL_TEMPLATE: 'emailTemplate',
  EMAIL_LOGS: 'emailLogs',
  EMAIL_LOG: 'emailLog',
  LOADING: 'loading',
  LIST: 'list',
  USER: 'user',
  SESSION_TOKEN: 'sessionToken',
  SINGLE: 'single',
  USER_ROLE: 'userRole',
  MENU_OPEN: 'menuOpen',
  MODAL: 'modal',
  MODAL_OPEN: 'modalOpen',
  ROWS: 'rows',
  SELECTED: 'selected',
  PAGINATION: 'pagination',
  TOKEN: 'token',
  TASKS: 'tasks',
  VAT_CODES: 'vat_codes',
}

export const FORM_KEYS = {
  USERNAME: 'username',
  PASSWORD: 'password',
}

export const EVENT_KEYS = {
  UNAUTH: 'unauth',
  SERVER_ERROR: 'serverError',
  LOGOUT: 'logout',
  NEW_TOKEN: 'newToken',
}
